import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { formValueSelector, destroy } from 'redux-form'
import flowRight from 'lodash/flowRight'
import { useLivedata } from '../shared/containers/withLivedata'
import DetailsContainer, { DetailsModal, constants as DCConstants } from '../DetailsContainer'
import withConstantPermissions from '../shared/containers/withConstantPermissions'
import ClientChecker from './ClientChecker'
import Footer from './Footer'
import { SMS_FORM_NAME, ENTRIES_FORM_NAME } from './constants'

import { getWindowName, getWindowShortName, getUri, addDays } from './helpers'
import config from './ClientPhysicalTabs'
import { Entries, SMS } from './Tabs'
import { PhysicalClientDetailsModalProps } from './types'
import { AppDispatch } from 'src/store/index.d'
const container = flowRight(
  withConstantPermissions(),
  withRouter,
  connect(
    //@ts-ignore
    (state, { match: { params } }) => ({
      smsStartDate: formValueSelector(SMS_FORM_NAME + params.ID)(state, 'StartDate'),
      smsEndDate: formValueSelector(SMS_FORM_NAME + params.ID)(state, 'EndDate'),
    }),
    (dispatch: AppDispatch) => ({
      destroySmsForm: (ID: string) => {
        dispatch(destroy(SMS_FORM_NAME + ID))
      },
      destroyEntriesForm: (ID: string) => {
        dispatch(destroy(ENTRIES_FORM_NAME + ID))
      },
    }),
  ),
)

const ClientDetails = ({
  match: { params },
  openDay,
  permissions,
  smsStartDate,
  smsEndDate,
  destroySmsForm,
  destroyEntriesForm,
}) => {
  const newConfig = { ...config }

  if (!permissions.CLIENT_MONITORING_VIEW) {
    delete newConfig.monitoring
  }

  if (!permissions.VIEW_USER_REPORTS) {
    delete newConfig.reports
  }

  if (!permissions.CLIENT_VIEW_IDDOC) {
    delete newConfig.general2
  }

  const tabs = () => ({
    ...newConfig,
    //@ts-ignore
    [Entries.config.name]: {
      //@ts-ignore
      ...Entries.config,
      getTabInitialParams: [() => ({ additionalParams: { StartDate: openDay, EndDate: openDay } })],
    },
    //@ts-ignore
    [SMS.config.name]: {
      //@ts-ignore
      ...SMS.config,
      getTabInitialParams: [
        undefined,
        () => ({
          additionalParams: {
            StartDate: smsStartDate || addDays(openDay, -1),
            EndDate: smsEndDate || openDay,
          },
        }),
      ],
    },
  })

  return (
    <>
      <DetailsContainer
        identifier="client-details--physical"
        type={DCConstants.InstanceTypes.Client}
        ID={params.ID}
        hash={params.hash}
        getWindowName={getWindowName}
        getWindowShortName={getWindowShortName}
        getUri={getUri}
        tabs={tabs}
        icon="client"
        defaultTabId="general"
        baseTabId="general"
        CheckerComponent={ClientChecker}
        Footer={Footer}
        iconCollection="client"
        onClose={() => {
          destroySmsForm(params.ID)
          destroyEntriesForm(params.ID)
        }}
      />
    </>
  )
}

const PhysicalClientDetailsModal = container((params: PhysicalClientDetailsModalProps) => {
  const {
    name,
    ID,
    hash,
    disabled,
    defaultTabId,
    icon,
    children,
    noTrigger,
    onClose,
    defaultTabIndex,
    permissions,
    destroySmsForm,
    destroyEntriesForm,
    smsStartDate,
    smsEndDate,
  } = params
  const newConfig = { ...config }

  const { openDay }: { openDay: string } = useLivedata('OpenDayStatus.Open_Day_Str as openDay')

  if (!permissions.CLIENT_MONITORING_VIEW) {
    delete newConfig.monitoring
  }

  if (!permissions.VIEW_USER_REPORTS) {
    delete newConfig.reports
  }

  const tabs = () => ({
    ...newConfig,
    //@ts-ignore
    [Entries.config.name]: {
      //@ts-ignore
      ...Entries.config,
      getTabInitialParams: [() => ({ additionalParams: { StartDate: openDay, EndDate: openDay } })],
    },
    //@ts-ignore
    [SMS.config.name]: {
      //@ts-ignore
      ...SMS.config,
      getTabInitialParams: [
        undefined,
        () => ({
          additionalParams: {
            StartDate: smsStartDate || addDays(openDay, -1),
            EndDate: smsEndDate || openDay,
          },
        }),
      ],
    },
  })

  return (
    <DetailsModal
      name={name}
      tabs={tabs}
      type={DCConstants.InstanceTypes.Client}
      ID={ID}
      disabled={disabled || false}
      hash={hash}
      getWindowName={getWindowName}
      getWindowShortName={getWindowShortName}
      getUri={getUri}
      icon={icon || 'client'}
      defaultTabId={defaultTabId || 'general'}
      defaultTabIndex={defaultTabIndex || 1}
      baseTabId="general"
      CheckerComponent={ClientChecker}
      Footer={Footer}
      iconCollection="client"
      noTrigger={noTrigger}
      onClose={() => {
        if (onClose) {
          onClose()
        }

        destroySmsForm(ID)
        destroyEntriesForm(ID)
      }}
    >
      {children}
    </DetailsModal>
  )
})

export { PhysicalClientDetailsModal }

export default container(ClientDetails)
